module.exports = __webpack_public_path__ + "static/media/piper-bg-green.5d8eeb76.svg";